export const languageStorePersistedPaths = [
  'languages',
  'interfaceLanguage',
] as const

/**
 * Pinia's JSON persistence cannot preserve Map instances. Treat any hydrated
 * non-Map value as an empty cache rather than letting callers fail on `.set()`.
 */
export function normalizeTranslationsByLanguage(
  value: unknown,
): Map<string, Map<string, string>> {
  return value instanceof Map ? value : new Map()
}
